import { useMutation } from '@tanstack/react-query';
import { ChangeEvent, FormEvent, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAlert } from '../../../AlertProvider';
import Button from '../../../components/Button';
import Card from '../../../components/Card';
import Input from '../../../components/Input';
import { alertType } from '../../../constants/alertTypeConstant';
import { requestStatus } from '../../../constants/requestStatusContants';
import { validationFunctions } from '../../../constants/validationConstants';
import ResetPasswordInterface from '../../../interfaces/ResetPasswordInterface';
import { resetPassword } from '../../../services/accountService';
import styles from './style.module.scss';

function ResetPassword() {
    const alert = useAlert();

    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');

    const { mutate } = useMutation({
        mutationFn: async (resetPasswordData: ResetPasswordInterface) => {
            const { data, status } = await resetPassword(resetPasswordData);
            const successStatus: number[] = [
                requestStatus.OK,
                requestStatus.Created,
                requestStatus.Accepted,
            ];
            if (successStatus.includes(status)) {
                alert.show({
                    children: 'Votre mot de passe a été modifié avec succès',
                    type: alertType[status],
                });
            } else {
                alert.show({
                    children:
                        'Erreur! Une erreur est survenue. Veuillez réessayer plus tard.',
                    type: alertType[status],
                });
            }
            return data;
        },
    });

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setPassword(value);
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (
            password.length === 0 ||
            email?.length === 0 ||
            token?.length === 0
        ) {
            return;
        }

        const resetPasswordData: ResetPasswordInterface = {
            email: email,
            newPassword: password,
            resetCode: token.replaceAll(' ', '+'),
        };
        mutate(resetPasswordData);
    };

    const passwordError = validationFunctions.password(password);
    return (
        <div className={styles.body}>
            <Card className={styles.container}>
                <h1>Nouveau mot de passe</h1>
                <Input
                    type="password"
                    label="Mot de passe"
                    name="password"
                    onChange={handleChange}
                    error={passwordError.errorMessage}
                />
                <div className={styles.action}>
                    <Button onClick={handleSubmit}>Envoyer</Button>
                </div>
            </Card>
        </div>
    );
}

export default ResetPassword;
